import React from "react";
import { Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

const SubmitButton = props => {
  const {
    loading,
    variant,
    size,
    color,
    type = "submit",
    href,
    disabled,
    startIcon,
    onClick,
    children,
    className,
    style
  } = props;

  const handleClick = e => {
    if (loading) return;
    onClick?.(e);
  };

  return (
    <Button
      variant={variant}
      size={size}
      type={type}
      color={color}
      className={className}
      href={href}
      disabled={disabled}
      onClick={handleClick}
      startIcon={
        loading ? (
          <CircularProgress
            size={16}
            style={{
              color: variant === "contained" ? "#fff" : color
            }}
          />
        ) : (
          startIcon
        )
      }
      style={
        loading ? { ...style, opacity: 0.7, pointerEvents: "none" } : style
      }
    >
      {children}
    </Button>
  );
};

export default SubmitButton;
